<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     布局模板 Menu 组件
  | @Version:   2018-11-27  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div v-if="$route.meta.layout == 0" class="the-layout-menu" :class="{ 'is-collapse': isCollapse }">
    <!-- <div class="title">{{ currentMenus.meta.title }}</div> -->
    <el-scrollbar class="sections" view-class="el-scrollbar-view" :class="{ 'collapse': !isCollapse }" :native="false">
      <el-menu :default-active="$route.name" @select="onSelect">
        <menu-section v-for="section in currentMenus.children" :key="section.name" :index="section.name" :section="section" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuSection from './components/MenuSection'

export default {
  name: 'TheLayoutMenu',
  components: {
    MenuSection
  },
  computed: {
    ...mapGetters([
      'currentMenus'
    ]),

    isCollapse() {
      return this.$store.state.commonStore.collapse
    },
  },
  methods: {
    onSelect(index, path) {
      if (path.indexOf(this.$route.name) > -1) {
        this.$router.push({ path: '/refresh' })
      } else {
        this.$router.push({ name: index })
      }
    }
  }
}
</script>

<style lang="scss">
$--layout-menu-bg: rgba(255, 255, 255, 1);
$--layout-menu-title-bg: #e5e8f0;
$--layout-menu-item-hover-fill: mix(#fff, $--layout-menu-bg, 45%);
$--layout-menu-item-active: #f9f9f9;
$--layout-menu-item-height: 40px;
.the-layout-menu {
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 160px;
  width: 180px;
  background-color: $--layout-menu-bg;
  color: #333;
  z-index: 1;
  border-bottom-left-radius: 20px;
  &.is-collapse {
    left: 60px;
    border-bottom-left-radius: 0px;
  }
  // .title {
  //   height: 60px;
  //   background-color: $--layout-menu-title-bg;
  //   padding: 0 20px;
  //   line-height: 60px;
  //   font-size: 18px;
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
  .sections {
    height: 100%;
    background-color:  rgba(255, 255, 255, 1);
    border-right: 1px solid #eee;
    &.collapse {
      border-bottom-left-radius: 20px;
    }
    .el-scrollbar-view {
      padding-bottom: 150px;
      overflow-x: hidden;
    }
    .el-menu {
      background-color: $--layout-menu-bg;
      border-right: 0;
      margin: 20px 15px;
      .el-submenu__title {
        height: $--layout-menu-item-height;
        line-height: $--layout-menu-item-height;
        &:hover, &focus {
          background-color: $--layout-menu-item-hover-fill;
        }
      }
      .el-menu-item {
        margin-bottom: 10px;
        border-radius: 5px;
        height: $--layout-menu-item-height;
        line-height: $--layout-menu-item-height;
        &:hover, &:focus {
          background-color: rgba(192, 196, 204, 0.3);
        }
        &.is-active {
          color: #07C160;
          background-color: rgba(7, 193, 96, 0.10);
        }
      }
    }
  }
}
</style>
